import {
  SET_SERVERS_LOADING,
  SET_SERVERS_DATA,
  ADD_SERVER,
  UPDATE_SERVER,
  DELETE_SERVER
} from "./types";
import { api } from "../App";

export const getServers = () => async (dispatch) => {
  try {
    dispatch({ type: SET_SERVERS_LOADING, payload: true });
    const { data } = await api.get('/monitoring_lms_cons/servers', { params: { limit: 150 } });
    dispatch({ type: SET_SERVERS_DATA, payload: data.servers || data });
  } catch (ERR) {
    console.error('Ошибка при загрузке серверов:', ERR);
  } finally {
    dispatch({ type: SET_SERVERS_LOADING, payload: false });
  }
}

export const createServer = (serverData) => async (dispatch) => {
  try {
    dispatch({ type: SET_SERVERS_LOADING, payload: true });
    const { data } = await api.post('/monitoring_lms_cons/servers', serverData);
    dispatch({ type: ADD_SERVER, payload: data.server || data });
    return { success: true, data };
  } catch (ERR) {
    console.error('Ошибка при создании сервера:', ERR);
    return { success: false, error: ERR.response?.data || ERR.message };
  } finally {
    dispatch({ type: SET_SERVERS_LOADING, payload: false });
  }
}

export const updateServer = (id, serverData) => async (dispatch) => {
  try {
    dispatch({ type: SET_SERVERS_LOADING, payload: true });
    const { data } = await api.put(`/monitoring_lms_cons/servers/${id}`, serverData);
    dispatch({ type: UPDATE_SERVER, payload: { id, data: data.server || data } });
    return { success: true, data };
  } catch (ERR) {
    console.error('Ошибка при обновлении сервера:', ERR);
    return { success: false, error: ERR.response?.data || ERR.message };
  } finally {
    dispatch({ type: SET_SERVERS_LOADING, payload: false });
  }
}

export const deleteServer = (id) => async (dispatch) => {
  try {
    dispatch({ type: SET_SERVERS_LOADING, payload: true });
    await api.delete(`/monitoring_lms_cons/servers/${id}`);
    dispatch({ type: DELETE_SERVER, payload: id });
    return { success: true };
  } catch (ERR) {
    console.error('Ошибка при удалении сервера:', ERR);
    return { success: false, error: ERR.response?.data || ERR.message };
  } finally {
    dispatch({ type: SET_SERVERS_LOADING, payload: false });
  }
}

